import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0",
    flat: ""
  }, {
    default: _withCtx(() => [
      (_ctx.vital)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { col: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.vital.date,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vital.date) = $event)),
                        label: "Date",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        type: "date",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.vital.time,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vital.time) = $event)),
                        label: "Time",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        type: "time",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.vital.systolic,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vital.systolic) = $event)),
                        label: "Systolic",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.vital.diastolic,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vital.diastolic) = $event)),
                        label: "Diastolic",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        color: "primary"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { col: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.vital.pulse,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vital.pulse) = $event)),
                        label: "Pulse",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.vital.oxygen,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vital.oxygen) = $event)),
                        label: "Oxygen",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.vital.temperature,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vital.temperature) = $event)),
                        label: "Temperature",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        color: "primary"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}